export enum ScopeType {
  // Top level action scopes
  ACTION_REQUEST_ACCESS = -10,
  ADD = 1,
  EDIT = 2,
  DELETE = 3,
  VIEW = 4,
  UPLOAD_REQUEST_DISABLED = 5,
  SHARE = 10,
  INVITE = 15,
  UPLOAD = 20,

  DOWNLOAD = 30,
}

export interface Scopes {
  e?: number[];
  a?: {
    '*'?: number[];
    [key: string]: number[];
  };
  v?: {
    'itmdta.views.form_admin.partners': number[];
  };
  r: {
    [key: string]: {
      s: number[];
    };
  };
  roles?: {
    /** Caller's ParticipationRole.roleValue on the deal. v2 keys this block by the
     *  JPA-ish name `participation` (Scopes#addRole("participation", ...)), not v1's `par`. */
    participation: number;
  };
  // v2 `ScopesAction` serializes as the uppercase enum name (was V1 'require_nda').
  action?: 'REQUIRE_NDA' | 'NDA_EXPIRED';
}
